import { Link } from 'react-router-dom';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white text-ink-900 antialiased">
      <Header />
      <main className="pt-28 md:pt-36 pb-16">
        <div className="max-w-xl mx-auto px-4 md:px-6 text-center py-20">
          <p className="font-display text-8xl font-bold text-ink-100 select-none">404</p>
          <h1 className="mt-4 font-display text-2xl font-bold text-ink-900">Page not found</h1>
          <p className="mt-3 text-ink-500">
            The page you&rsquo;re looking for doesn&rsquo;t exist or has been moved.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/"
              className="h-10 px-5 rounded-lg bg-ink-900 hover:bg-ink-700 text-white text-sm font-semibold transition"
            >
              Go home
            </Link>
            <Link
              to="/search"
              className="h-10 px-5 rounded-lg border border-ink-200 hover:border-ink-300 text-ink-700 text-sm font-semibold transition"
            >
              Browse products
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
